import { Box } from '@chakra-ui/react'
import { useMemo } from 'react'
import { Product } from './Product'

export function ListProducts({ list, selectedItems, handleSelectItem, dadosPedido, dadosFaturamento, consultor, caricatura }) {
  const selectedItemsRef = useMemo(() => new Set(selectedItems), [selectedItems])

  return (
    <>
      <Box display="flex" flexDir="column" gap={4}>
        {list.map((item, index) => (
          <Product
            product={item}
            key={index}
            consultor={consultor}
            dadosFaturamento={dadosFaturamento}
            handleSelectItem={handleSelectItem}
            isSelected={selectedItemsRef.has(item)}
            dadosPedido={dadosPedido}
            caricatura={caricatura}
          />
        ))}
      </Box>
    </>
  )
}
